import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { ownAccount } from '../api/user';
import AccountContext from '../context/AccountContext';

export default function useCheckAuth() {
  const navigate = useNavigate();
  const { setAccountResponse } = useContext(AccountContext);

  async function getOwnAccount() {
    const r = await ownAccount();
    localStorage.setItem('user', JSON.stringify(r));
    setAccountResponse(r);
  }

  return async (disableRedirect = false) => {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    if (user?.accessToken) {
      try {
        await getOwnAccount();
      } catch (e) {
        console.log(e); // todo: remove this line
      }
      if (!disableRedirect) {
        navigate('/');
      }
    }
  };
}
